import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import logo from "../../assets/images/Latest Logo.png";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { styled } from "@mui/system";
import { GoLightBulb } from "react-icons/go";
import { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import Fade from "react-reveal/Fade";
import AI_image from "../../assets/images/Profile Tracking V1.jpg";
import Mass_mailing from "../../assets/images/Consultant Tracking.jpg";
import Consultant_searching from "../../assets/images/Job Posting.jpg";
import Profile_picture from "../../assets/images/Happy Girl V2.jpg";
import { keyframes } from "@emotion/react";

const OurPlatform = ({ title, progress, color }) => {
  const navigate = useNavigate();

  const [typeResult, setTypeResult] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const gender = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];
  const textAnimation = keyframes`
  from {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  }
  to {
    clip-path: polygon(0 0, 0% 1%, 0% 100%, 0% 100%);
  }
`;

  const cursorAnimation = keyframes`
  from {
    width: 100%;
  }
  to {
    width: 0;
  }
`;
  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>Home</b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b style={{ marginLeft: "5px", fontSize: "16px ", fontWeight:"500" }}>Our Platform</b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>About us</b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>Contact us</b>
          </a>
          <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                About us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Contact us
              </b>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>

      <Box sx={{ padding: "35px" }} id="home" />
      <Box className={styles.home_structure}>
        <Box className={styles.platform_details}>
          <Fade bottom delay={200}>
            <Grid item xs={12} sm={6} md={12} lg={12}>
              <Box>
                <Typography sx={{ fontSize: "20px !important" }}>
                  <b>Our Platform</b>
                </Typography>
                <Typography
                  sx={{ fontSize: "16px !important", marginTop: "10px" }}
                >
                  Our user friendly and AI integrated platform that allow to
                  track candidate and job requirements and multiple your number
                  of appropriate candidate, tracking and identifying the right
                  fit easier, faster, and find what talent end-to-end applicant
                  tracking looks like Povital ATS. Also our AI-powered system
                  automatically delivers accurate result to staffing
                  professional including candidate, IT recruiter, Bench Sales
                  Recruiter and staffing agencies your dashboard while
                  integrating with your daily workflow for more efficient talent
                  acquisition specialist and data insight.
                </Typography>
              </Box>
            </Grid>
          </Fade>
        </Box>

        <Box className={styles.platform_details}>
          <Fade bottom delay={200}>
            <Grid
              container
              sx={{ alignSelf: "end", width: "100%", marginTop: "40px" }}
            >
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={AI_image}
                    alt="AI Representation"
                    style={{
                      width: "100%",
                      maxWidth: "300px",
                      height: "auto",
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={8} lg={8}>
                <Box>
                  <Typography sx={{ fontSize: "20px !important" }}>
                    <b>AI Powered Tracking System</b>
                  </Typography>
                  <Typography
                    sx={{ fontSize: "16px !important", marginTop: "10px" }}
                  >
                    Povital provide highly interactive AI Powered Applicants
                    tracking facilities for all staffing professionals that
                    allow to unlimited candidates and job requirements just in
                    few click also povital represent AI integrated dashboard
                    which helps to count talent for next job requirements along
                    with all the details of respective IT talents and
                    associates.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Fade>
        </Box>

        <Box className={styles.platform_details}>
          <Fade bottom delay={200}>
            <Grid
              container
              sx={{ alignSelf: "end", width: "100%", marginTop: "40px" }}
            >
              <Grid item xs={12} sm={6} md={8} lg={8}>
                <Box>
                  <Typography sx={{ fontSize: "20px !important" }}>
                    <b>Timelines & Mass Mailing </b>
                  </Typography>
                  <Typography
                    sx={{ fontSize: "16px !important", marginTop: "10px" }}
                  >
                    Povital help to connect and transfer the job requirements to
                    highly matching candidates and employers with help of our
                    powerful AI integrated feature also provide personalized
                    features to the staffing professionals.
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={Mass_mailing}
                    alt="Mass Mailing"
                    style={{
                      width: "100%",
                      maxWidth: "380px",
                      height: "auto",
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Fade>
        </Box>

        <Box className={styles.platform_details}>
          <Fade bottom delay={200}>
            <Grid
              container
              sx={{ alignSelf: "end", width: "100%", marginTop: "40px" }}
            >
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={Consultant_searching}
                    alt="Candidate Searching"
                    style={{
                      width: "100%",
                      maxWidth: "270px",
                      height: "auto",
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={8}
                lg={8}
                sx={{
                  marginTop: isMobile ? "20px" : "0px",
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: "20px !important" }}>
                    <b>AI-Integrated Candidate Sourcing & Searching</b>
                  </Typography>
                  <Typography
                    sx={{ fontSize: "16px !important", marginTop: "10px" }}
                  >
                    Advantage the endless power of artificial intelligence to
                    dive into candidate analytics and evaluate prospects to
                    increase placement success possibilities—while you’re
                    pulling your candidate from your current workforce, or
                    discovering new candidate for the first time so povital
                    highly recommended AI powered search engine that helps to
                    get appropriate talent as per the job requirements along so
                    many AI filtrations behind of the requirement also povital
                    offer manual searching according to user preferences with
                    super easy and user friendly interface.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Fade>
        </Box>
        <Fade bottom delay={200}>
          <Box
            sx={{
              backgroundColor: "#2D4696",

              padding: { xs: "15px", md: 0 },
            }}
          >
            <Grid
              container
              sx={{
                alignSelf: "center",
                width: "100%",
                marginTop: { xs: "0", md: "40px" },
              }}
              spacing={2} // Add spacing between Grid items for better mobile view
            >
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box className={styles.image_contain}>
                  <img
                    src={Profile_picture}
                    alt="Profile"
                    style={{ width: "100%", maxWidth: "200px", height: "auto" }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={9}
                lg={9}
                sx={{
                  margin: { xs: "20px 0 0 0", sm: "0" }, // Add margin on small devices
                  padding: { xs: "10px" }, // Add some padding on smaller screens
                }}
              >
                <Box className={styles.povital_contain}>
                  <Typography>
                    <Box>
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: "bold",

                          fontSize: {
                            xs: "30px",
                            md: "35px",
                          },
                          color: "#fff",
                          position: "relative",
                          left: "15px",
                          bottom: { xs: "35px", md: "20px" },
                        }}
                      >
                        Why go with Povital?
                      </Typography>

                      {/* <Typography
                        variant="h2"
                        sx={{
                          position: "relative",
                          color: "#34a853",
                          fontWeight: "600",
                          fontFamily: "Helvetica",
                          fontSize: {
                            xs: "30px",
                            md: "50px",
                          },
                          textShadow: "1px 1px 1px black, -1px -1px 1px black",
                          position: "absolute",
                          top: "0",
                          width: "100%",
                          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
                          animation: `${textAnimation} 10s ease-in-out forwards alternate infinite`,
                        }}
                      >
                        Why go with Povital?
                      </Typography> */}

                      {/* <Typography
                        variant="h2"
                        sx={{
                          position: "relative",
                          color: "transparent",
                          fontWeight: "600",
                          fontFamily: "Helvetica",
                          fontSize: {
                            xs: "30px",
                            md: "50px",
                          },
                          top: "0",
                          height: "20%",
                          width: "100%",
                        }}
                      >
                        Why go with Povital
                      </Typography> */}
                    </Box>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "15px !important",
                        md: "17px !important",
                      },
                      position: "relative",
                      top: { xs: "0", md: "15px" },
                      left: { xs: "10px" },

                      color: "#fff",
                    }}
                  >
                    Because staffing professionals know about our features and
                    services.
                    <br className={styles.resposive_break} />
                    that even with the best AI technology is only as good as the
                    people behind it. That's why we
                    <br className={styles.resposive_break} />
                    offer the best user-friendly platform.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Box>

      <Footer />
    </Box>
  );
};

export default OurPlatform;
